var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"sinvalor"},[_vm._v(_vm._s(_vm.props.mensaje ? _vm.props.mensaje : "(sin datos)"))])}
var staticRenderFns = []

export { render, staticRenderFns }